import { Component, OnInit } from "@angular/core";
import { GlobalHeaderDataService } from "../global-header-data.service";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-global-footer",
  templateUrl: "./global-footer.component.html",
  styleUrls: ["./global-footer.component.scss"],
})
export class GlobalFooterComponent implements OnInit {
  supportLink = environment.SUPPORT_LINKS.base_link;
  releaseVersion = "";
  usersnapJsKey: string;
  snapEmail: string;
  userName: string;
  currentYear: number;
  constructor(
    private dataService: GlobalHeaderDataService,
    private store: Store<AppState>,
  ) {
    store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        this.usersnapJsKey = data.usersnapJsKey;
        this.snapEmail = data.userDetails ? data.userDetails.email : "";
        this.userName = data.userName;
      });
  }

  ngOnInit() {
    this.dataService.getReleaseVersion().subscribe((data: any) => {
      this.releaseVersion = data.data.release_version;
    });
    const todayForTheYear = new Date();
    this.currentYear = todayForTheYear.getFullYear();
  }

  onClickFeedback() {
    if (this.usersnapJsKey && this.usersnapJsKey !== "") {
      window.Usersnap.init({
        button: { isHidden: true },
      });
      window.Usersnap.on("open", (event) => {
        event.api.setValue("custom", {
          email: `##${this.snapEmail}##`,
          username: this.userName,
        });
        event.api.setValue("email", this.snapEmail);
        event.api.setValue("comment", "");
      });
      setTimeout(function () {
        window.Usersnap.open();
      }, 1000);
    }
  }
}
